import { Fragment } from 'react';
import { useSelector } from 'react-redux';
import useTwoBadgesCoexistenceABTest from '../../../hooks/ab-tests/use-two-badges-coexistence-abtest';
import translation from '../../../languages';
import cn from '../../../utils/classnames';
import getMaterialLabels from '../../../utils/material/get-material-labels';
import {
    MATERIAL_LABELS_VARIANTS,
    MATERIAL_LABELS_VARIANT_CONFIG,
    MaterialLabelsVariant,
    SINGLE_LABEL
} from './material-labels.constants';
import { renderMaterialLabel } from './material-labels.renderers';
import './material-labels.scss';

type MaterialLabelsProps = TranslationProps & {
    item: Material;
    variant?: MaterialLabelsVariant;
    className?: string;
};

const MaterialLabels = (props: MaterialLabelsProps) => {
    const { item, variant = MATERIAL_LABELS_VARIANTS.ONE_LABEL, className, t } = props;

    const { excludedLabels, hasTooltips, maxLabels } = MATERIAL_LABELS_VARIANT_CONFIG[variant];
    const { countryCode } = useSelector((state: RootState) => state.main.geotargeting);

    const labels = getMaterialLabels({ item, countryCode, excludedLabels });

    // AB TEST - 1596: read only where the variant allows more than one label and A and B can actually differ
    const hasCombinedLabels = maxLabels > SINGLE_LABEL && labels.length > SINGLE_LABEL;
    const isTwoLabelsVariant = useTwoBadgesCoexistenceABTest(hasCombinedLabels);
    const labelsToShow = labels.slice(0, isTwoLabelsVariant ? maxLabels : SINGLE_LABEL);

    if (!labelsToShow.length) {
        return null;
    }

    return (
        <div className={cn('material-labels', className)}>
            {labelsToShow.map((label) => (
                <Fragment key={label}>
                    {renderMaterialLabel({ name: label, item, hasTooltip: hasTooltips, t })}
                </Fragment>
            ))}
        </div>
    );
};

const translate = translation('common');

export default translate(MaterialLabels);
